import React, {createContext, useReducer} from "react";
import {InductFilterReducer} from "../reducers/InductFilterReducer";

export const InductFilterContext = createContext();

const InductFilterContextProvider = (props) => {
    const inductFilter = {
        allCycles:[],
        selectedCycles:[],
        allCPT:[],
        selectedCPT:[],
        CPTLabel: '',
        filterIdentifier: 'CPT'
    }

    const [filter, dispatch ] = useReducer(InductFilterReducer, inductFilter)
    return (
        <InductFilterContext.Provider value = {{filter, dispatch}}>
            {props.children}
        </InductFilterContext.Provider>
    )
}

export default InductFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/induct/context/InductFilterContext.js